module.exports = __webpack_public_path__ + "static/media/01-final-mobile.ca6c9817.webp";